module.exports = __webpack_public_path__ + "img/图片3.e0e91909.jpg";